import { TangerineBoxEventTrackerForLibrary } from "../vendor";
function getTracker() {
    return TangerineBoxEventTrackerForLibrary.getInstance({
        // Comes from this stack: https://code.amazon.com/packages/AwsUi-Widget-AppLayout-MonitoringCDK/blobs/27e6a33ef0ce2c449cabee53f9b6a5077d8f1627/--/src/stacks/telemetry.ts#L22
        token: "v1/dd372068bbfd34f30345fea72c48142cb7ebbce8815bd70c7a19fac778b06425",
    });
}
export function emitLoadEvent(startTime, metadataTime, finishTime) {
    getTracker().addEvent({
        payload: {
            metricName: "appLayoutWidgetJsLoaded",
            count: 1,
            metadataTime: metadataTime - startTime,
            loadTime: finishTime - metadataTime,
            totalTime: finishTime - startTime,
        },
    });
}
export function emitErrorEvent(error) {
    getTracker().addError(error, {
        payload: {
            metricName: "appLayoutWidgetJsError",
            count: 1,
        },
    });
}
